<template>
  <listing-layout :style="{ '--apperances-color': computedColor }" no-sm-padding>
    <div slot="heading" class="d-flex justify-content-between align-items-center mb-3">
      <h1 class="nominate__title h2 mb-3">{{ draft && draft.name ? draft.name : '' }}</h1>
    </div>
    <div slot="content" class="leaders">
      <div class="alert alert-warning" v-if="error">{{ error }}</div>

      <statistics v-if="statistics" :statistics="statistics" :appearances="appearances" />

      <div class="leaders-event__body" style="margin-top: 24px;">
        <ul class="leaders-event__main-row">
          <li class="col-1 col-sm-2 tac">Rank</li>
          <li class="col-11 col-sm-10 display-mob">Info</li>
          <li class="col-3 hidden-mob">Rider</li>
          <li class="col-3 hidden-mob">Horse</li>
          <li class="col-2 hidden-mob">Event Name</li>
          <li class="col-1 hidden-mob">Round</li>
          <li class="col-1 tac hidden-mob">Cutout</li>
        </ul>

        <div v-if="loading && !draws.length" class="text-center py-3">
          Loading...
        </div>

        <ul v-for="(draw, idx) in draws" :key="draw.id">
          <li class="col-1 col-sm-2 tac">{{ draw.rank || (idx + 1) }}</li>
          <li class="col-11 col-sm-10 display-mob">
            <div><span>Rider name:</span> <link-rider :draw="draw" /></div>
            <div><span>Horse name:</span> {{ draw.horse_name }}</div>
            <div v-if="draw.event"><span>Event name:</span> {{ draw.event.name }}</div>
            <div v-if="draw.event && draw.event.round"><span>Round:</span> {{ draw.event.round.round + 1 }}</div>
            <div><span>Cutout:</span> {{ draw.cutout }}</div>
          </li>
          <li class="col-3 hidden-mob"><link-rider :draw="draw" /></li>
          <li class="col-3 hidden-mob">{{ draw.horse_name }}</li>
          <li class="col-2 hidden-mob">{{ draw.event ? draw.event.name : '—' }}</li>
          <li class="col-1 hidden-mob">{{ draw.event && draw.event.round ? draw.event.round.round + 1 : '—' }}</li>
          <li class="col-1 tac hidden-mob">{{ draw.cutout !== null && draw.cutout !== undefined ? draw.cutout : '-' }}</li>
        </ul>

        <div ref="infiniteTrigger"></div>

        <div v-if="loading && draws.length" class="text-center py-3">
          Loading...
        </div>
      </div>

    </div>
  </listing-layout>
</template>

<script>
import listingLayout from '@/components/ListingLayout'
import getAppearances from '../Listing/mixins/getAppearances'
import getStatistics from '../Listing/mixins/getStatistics'
import Statistics from '../Listing/components/Statistics'
import fetchData from '../../../mixins/apiHelpers'
import LinkRider from '../Listing/components/Links/LinkRider'

export default {
  name: 'LeadersDraftCutoutHighest',
  mixins: [getAppearances, getStatistics],
  computed: {
    entity() {
      return {
        model: 'draft',
        id: this.$route.params.draft_id
      }
    },
    computedColor() {
      return this.appearances && this.appearances.schema_color
        ? `${this.appearances.schema_color}`
        : 'var(--primary)'
    }
  },
  components: {
    'listing-layout': listingLayout,
    Statistics,
    'link-rider': LinkRider
  },
  data() {
    return {
      draft: null,
      draws: [],
      error: null,
      page: 1,
      loading: false,
      finished: false,
      observer: null
    }
  },
  provide() {
    const self = this
    return {
      get entity() {
        return {
          model: 'draft',
          id: self.$route.params.draft_id
        }
      }
    }
  },
  async mounted() {
    await this.fetchDraft()
    await this.fetchStatistics()
    this.fetchDraws()
  },
  methods: {
    initObserver() {
      if (!this.$refs.infiniteTrigger) return
      this.observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && !this.loading && !this.finished) {
          this.fetchDraws()
        }
      }, {
        root: null,
        rootMargin: '300px',
        threshold: 0
      })
      this.observer.observe(this.$refs.infiniteTrigger)
    },
    async fetchDraft() {
      await fetchData(`${this.$api}/leaders/drafts/${this.entity.id}`, (response) => {
        this.draft = response.data.data.draft
        this.$root.$emit('update-breadcrumb', {
          name: 'Draft',
          link: `leaders/drafts/${this.entity.id}`
        })
      }, this)
    },
    async fetchDraws() {
      if (this.loading || this.finished) return
      this.loading = true

      const query = new URLSearchParams()
      query.append('page', this.page)

      await fetchData(
        `${this.$api}/leaders/drafts/${this.$route.params.draft_id}/cutout-highest?${query.toString()}`,
        (response) => {
          const data = response.data.data
          const meta = response.data.meta
          const newDraws = data.draws || []

          this.draws.push(...newDraws)

          if (!newDraws.length || (meta && this.page >= meta.last_page)) {
            this.finished = true
          } else {
            this.page++
            this.$nextTick(() => {
              if (!this.observer) this.initObserver()
            })
          }
        },
        this
      )

      this.loading = false
    }
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }
}
</script>

<style scoped>
  .leaders a {
    color: var(--apperances-color) !important;
  }

  .nominate__title {
    color: var(--apperances-color) !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/Leaders/CutoutHighest/Draft.vue